import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Form } from 'reactstrap';
import { Button } from '../../../components/Component';

const CardEditModal = ({ show, onHide, card, onSave, isLoading }) => {
    const [formData, setFormData] = useState({
        title: '',
        link: '',
        section_id: ''
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (card) {
            setFormData({
                title: card.title || '',
                link: card.link || '',
                section_id: card.section_id || ''
            });
        } else {
            setFormData({
                title: '',
                link: '',
                section_id: ''
            });
        }
        setErrors({});
    }, [card, show]);

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.title.trim()) {
            newErrors.title = 'Card title is required.';
        }
        
        if (formData.link && formData.link.trim()) {
            const link = formData.link.trim();
            // Basic URL validation
            if (!link.startsWith('http://') && !link.startsWith('https://') && !link.startsWith('/')) {
                newErrors.link = 'Link must be a valid URL (starting with http://, https://) or an internal path (starting with /).';
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }

        const payload = {
            ...formData,
            title: formData.title.trim(),
            link: formData.link.trim()
        };

        if (card?.id) {
            payload.id = card.id;
        }

        onSave(payload);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        
        // Clear error for this field when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleClose = () => {
        setFormData({
            title: '',
            link: '',
            section_id: ''
        });
        setErrors({});
        onHide();
    };

    return (
        <Modal isOpen={show} toggle={handleClose} size="lg">
            <ModalHeader toggle={handleClose}>
                {card?.id ? 'Edit Card' : 'Create New Card'}
            </ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    <FormGroup>
                        <Label htmlFor="cardTitle">Card Title *</Label>
                        <Input
                            type="text"
                            id="cardTitle"
                            name="title"
                            value={formData.title}
                            onChange={handleInputChange}
                            placeholder="Enter card title"
                            disabled={isLoading}
                            invalid={!!errors.title}
                            required
                        />
                        {errors.title && <div className="invalid-feedback d-block">{errors.title}</div>}
                    </FormGroup>



                    <FormGroup>
                        <Label htmlFor="cardLink">Link</Label>
                        <Input
                            type="text"
                            id="cardLink"
                            name="link"
                            value={formData.link}
                            onChange={handleInputChange}
                            placeholder="https://example.com or /internal-page"
                            disabled={isLoading}
                            invalid={!!errors.link}
                        />
                        {errors.link && <div className="invalid-feedback d-block">{errors.link}</div>}
                        <small className="form-text text-muted">
                            Enter a URL (starting with http:// or https://) for external links, or a path starting with / for internal links.
                        </small>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="light" onClick={handleClose} disabled={isLoading}>
                        Cancel
                    </Button>
                    <Button color="primary" type="submit" disabled={isLoading}>
                        {isLoading ? (card?.id ? 'Saving...' : 'Creating...') : (card?.id ? 'Save Changes' : 'Create Card')}
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default CardEditModal; 